module.exports = __webpack_public_path__ + "img/create.b60081c9.png";